import { render } from "./print-stock-transfer.vue?vue&type=template&id=56b2ff7c"
import script from "./print-stock-transfer.vue?vue&type=script&lang=js"
export * from "./print-stock-transfer.vue?vue&type=script&lang=js"

import "./print-stock-transfer.vue?vue&type=style&index=0&id=56b2ff7c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__